module.exports = __webpack_public_path__ + "static/1 (5)-83c3b4c970e9ae8b28bb4b33d28ff7f0.jpg";